import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-calendar3-fill",
  "use": "icon-calendar3-fill-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" class=\"bi bi-calendar3-fill\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-calendar3-fill\">\r\n  <path d=\"M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2H0z\" />\r\n  <path fill-rule=\"evenodd\" d=\"M0 3h16v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/calendar3-fill.svg
// module id = ux3d
// module chunks = 60